import { createRoot } from 'react-dom/client';

import DebtWarning from '@containers/DebtWarning';

const debtWarning = document.querySelector<HTMLElement>('#js-debt-warning');

if (debtWarning) {
  const root = createRoot(debtWarning);

  root.render(<DebtWarning />);
}
